import { useState, useRef, useEffect } from "react";
import { defaultMessage } from "./config";

const useVirtualHuman = () => {
  const [chatList, setChatList] = useState(defaultMessage);

  const [pendingText, setPendingText] = useState(""); // 等待被渲染的文本

  const [lockTextState, setLockTextState] = useState(false); // 是否开始渲染

  const [isStreaming, setIsStreaming] = useState(false);

  const currentIndex = useRef(0);

  const isLock = useRef(false);

  useEffect(() => {
    let timer;
    if (!lockTextState) {
      currentIndex.current = 0;
      return;
    }
    if (timer) {
      clearInterval(timer); // 清除之前的定时器
    }
    console.log(pendingText, "pendingText");
    timer = setInterval(() => {
      if (currentIndex.current > pendingText.length) {
        isLock.current = false;
        setIsStreaming(false);
        clearInterval(timer);
        return;
      }
      currentIndex.current += 1;
      setIsStreaming(true);
      setLastMessageText(pendingText.slice(0, currentIndex.current));
    }, 30);

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingText, lockTextState]);

  // 新增一条空消息
  const addNullMessage = (type = "receive") => {
    setChatList((cl) => {
      return [
        ...cl,
        {
          type: type,
          text: "",
        },
      ];
    });
  };

  // 设置最后一行的输出
  const setLastMessageText = (text) => {
    setChatList((cl) => {
      if (cl[cl.length - 1]) {
        cl[cl.length - 1].text = text;
      }
      return [...cl];
    });
  };

  // 检测最后一行如果是空值时，则删除
  const clearNullMessage = () => {
    setChatList((cl) => {
      if (!cl[cl.length - 1]?.text) {
        cl.pop();
      }
      return cl;
    });
  };

  const deleteLastMessage = () => {
    setChatList((cl) => {
      cl.pop();
      return cl;
    });
  };

  // 重置列表
  const resetList = () => {
    setTimeout(() => {
      setChatList(defaultMessage);
    }, 100);
  };

  return {
    chatList,
    isStreaming,
    resetList,
    addNullMessage,
    setLastMessageText,
    setPendingText,
    setLockTextState,
    clearNullMessage,
    deleteLastMessage,
  };
};

export { useVirtualHuman };
